__turbopack_context__.v({
  "base": "DeveloperKit-module__m8RPsq__base",
  "baseinner": "DeveloperKit-module__m8RPsq__baseinner",
  "content": "DeveloperKit-module__m8RPsq__content",
  "contentBox": "DeveloperKit-module__m8RPsq__contentBox",
  "hierarchy": "DeveloperKit-module__m8RPsq__hierarchy",
  "row": "DeveloperKit-module__m8RPsq__row",
  "rowFirst": "DeveloperKit-module__m8RPsq__rowFirst",
  "title": "DeveloperKit-module__m8RPsq__title",
});
